import { FC } from 'react'
import { useTranslation } from '../../../../hooks/locale'
import { useSmartSearch } from '../hooks'
import SmartSearchField from '../smart-search-field'
import Spinner from '../../../common/spinner'
import AiAvatar from '../ai-avatar'
import { Container, Header, SubmitButton, Title } from './styles'

const noop = () => {}

interface Props {
    onSuccess?: () => void
}

const SmartSearchPanel: FC<Props> = ({ onSuccess = noop }) => {
    const { t } = useTranslation()
    const { text, setText, hasError, isLoading, canSubmit, submit } = useSmartSearch({ onSuccess, onError: noop })

    return (
        <Container>
            <Header>
                <AiAvatar size="medium" />
                <Title>{t('smartSearch.desktopTitle')}</Title>
            </Header>

            <SmartSearchField value={text} onChange={setText} hasError={hasError} variant="desktop" />

            <SubmitButton type="button" onClick={() => submit()} disabled={!canSubmit}>
                {isLoading && <Spinner $size="1rem" />}
                {t('smartSearch.desktopSubmit')}
            </SubmitButton>
        </Container>
    )
}

export default SmartSearchPanel
